import { render, staticRenderFns } from "./WebAuthnUserResetPasswordHandler.vue?vue&type=template&id=637d963e"
import script from "./WebAuthnUserResetPasswordHandler.vue?vue&type=script&lang=ts"
export * from "./WebAuthnUserResetPasswordHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports